export default __webpack_public_path__ + "static/media/home-qualification31.6baf0af7.png";